import * as React from 'react';

export interface UsageBarPlotProps {
    folderUsage: number;
    totalUsage: number;
    barIndex: number;
}

const styles = require('./UsageBarPlot.scss');

export default function UsageBarPlot(props: UsageBarPlotProps) {
    return (
        <div
            className={getUsageBarStyle(props.barIndex)}
            style={{ width: (100 * props.folderUsage) / props.totalUsage + '%' }}></div>
    );
}

function getUsageBarStyle(barIndex: number) {
    switch (barIndex) {
        case 0:
            return styles.bar1;
        case 1:
            return styles.bar2;
        case 2:
            return styles.bar3;
        case 3:
            return styles.bar4;
    }
}
